import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { translations, Language, Translations } from './translations';

interface I18nState {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: Translations;
}

export const useI18n = create<I18nState>()(
  persist(
    (set, get) => ({
      language: 'sr',
      setLanguage: (language) => set({ language, t: translations[language] }),
      t: translations.sr,
    }),
    {
      name: 'svojnasvom-i18n',
      onRehydrate: (state) => {
        // Ensure translations are synced after rehydration
        return (rehydratedState) => {
          if (rehydratedState) {
            rehydratedState.t = translations[rehydratedState.language];
          }
        };
      },
    }
  )
);

export { translations, type Language, type Translations };
